import axios from 'axios';
import UIHelper from 'helpers/UIHelper';

export default function configureAxios() {
  axios.interceptors.response.use(
    (response) => {
      const isSignInResponse = response?.config?.url.includes('/auth');
      const isCreateOrUpdateResponse = ['post', 'put', 'patch'].includes(
        response?.config?.method,
      );

      if (
        response.status < 300 &&
        !isSignInResponse &&
        isCreateOrUpdateResponse
      ) {
        UIHelper.openNotificationWithIcon('success', 'L’operazione è stata completata con successo');
      }
      return response;
    },
    (error) => {
      if (error?.response?.status >= 500) {
        UIHelper.serverError();
      }
      return Promise.reject(error);
    },
  );
}
